import { useMemo } from 'react'
import { useQuery } from '@tanstack/react-query'
import { useTranslation } from 'react-i18next'
import { Download, ExternalLink } from 'lucide-react'
import { buildJoinLink, parseJoinLink } from '@pusula/shared'
import { PortalCard } from './PortalAuthPages'
import { portalApi, type DesktopRelease } from './portal-api'

/**
 * Davet e-postasındaki yedek link: `<portal>/join#d=…&t=…`. Bilgiler `#` sonrasında olduğu için
 * sunucuya gönderilmez; sayfa Pusula'yı `pusula://join` ile açar, yüklü değilse indirme linki verir.
 */
export function JoinPage(): JSX.Element {
  const { t } = useTranslation('portal')
  const invite = useMemo(() => parseJoinLink(window.location.hash.slice(1)), [])
  const { data: releases } = useQuery({
    queryKey: ['portal-downloads'],
    queryFn: () => portalApi.get<{ data: DesktopRelease[] }>('/portal/downloads').then((r) => r.data.data),
  })
  const installer = releases?.find((r) => !r.prerelease && r.installer)?.installer

  if (!invite) return <PortalCard title={t('join.invalidTitle')} subtitle={t('join.invalid')}><span /></PortalCard>

  return (
    <PortalCard title={t('join.title', { company: invite.companyName })} subtitle={invite.token ? t('join.invited') : t('join.connection')}>
      <div className="space-y-4 text-sm">
        <a className="btn-primary flex w-full items-center justify-center gap-2" href={buildJoinLink(invite)}>
          <ExternalLink className="h-4 w-4" />{t('join.open')}
        </a>
        <p className="text-muted-foreground">{t('join.notInstalled')}</p>
        {installer && (
          <a className="btn-secondary flex w-full items-center justify-center gap-2" href={installer.url}>
            <Download className="h-4 w-4" />{t('join.download')}
          </a>
        )}
        <p className="text-xs text-muted-foreground">{t('join.after')}</p>
      </div>
    </PortalCard>
  )
}
